"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _transform = require("./flat/transform.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/Circle
 */


/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */
var Circle =
/** @class */
function (_super) {
  __extends(Circle, _super);
  /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `opt_layout` and no
   *     `opt_radius` are also accepted.
   * @param {number} [opt_radius] Radius.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   */


  function Circle(center, opt_radius, opt_layout) {
    var _this = _super.call(this) || this;

    if (opt_layout !== undefined && opt_radius === undefined) {
      _this.setFlatCoordinates(opt_layout, center);
    } else {
      var radius = opt_radius ? opt_radius : 0;

      _this.setCenterAndRadius(center, radius, opt_layout);
    }

    return _this;
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   */


  Circle.prototype.clone = function () {
    var circle = new Circle(this.flatCoordinates.slice(), undefined, this.layout);
    circle.applyProperties(this);
    return circle;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  Circle.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    var flatCoordinates = this.flatCoordinates;
    var dx = x - flatCoordinates[0];
    var dy = y - flatCoordinates[1];
    var squaredDistance = dx * dx + dy * dy;

    if (squaredDistance < minSquaredDistance) {
      if (squaredDistance === 0) {
        for (var i = 0; i < this.stride; ++i) {
          closestPoint[i] = flatCoordinates[i];
        }
      } else {
        var delta = this.getRadius() / Math.sqrt(squaredDistance);
        closestPoint[0] = flatCoordinates[0] + delta * dx;
        closestPoint[1] = flatCoordinates[1] + delta * dy;

        for (var i = 2; i < this.stride; ++i) {
          closestPoint[i] = flatCoordinates[i];
        }
      }

      closestPoint.length = this.stride;
      return squaredDistance;
    } else {
      return minSquaredDistance;
    }
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */


  Circle.prototype.containsXY = function (x, y) {
    var flatCoordinates = this.flatCoordinates;
    var dx = x - flatCoordinates[0];
    var dy = y - flatCoordinates[1];
    return dx * dx + dy * dy <= this.getRadiusSquared_();
  };
  /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */


  Circle.prototype.getCenter = function () {
    return this.flatCoordinates.slice(0, this.stride);
  };
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */


  Circle.prototype.computeExtent = function (extent) {
    var flatCoordinates = this.flatCoordinates;
    var radius = flatCoordinates[this.stride] - flatCoordinates[0];
    return (0, _extent.createOrUpdate)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
  };
  /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */


  Circle.prototype.getRadius = function () {
    return Math.sqrt(this.getRadiusSquared_());
  };
  /**
   * @private
   * @return {number} Radius squared.
   */


  Circle.prototype.getRadiusSquared_ = function () {
    var dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
    var dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
    return dx * dx + dy * dy;
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  Circle.prototype.getType = function () {
    return _GeometryType["default"].CIRCLE;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  Circle.prototype.intersectsExtent = function (extent) {
    var circleExtent = this.getExtent();

    if ((0, _extent.intersects)(extent, circleExtent)) {
      var center = this.getCenter();

      if (extent[0] <= center[0] && extent[2] >= center[0]) {
        return true;
      }

      if (extent[1] <= center[1] && extent[3] >= center[1]) {
        return true;
      }

      return (0, _extent.forEachCorner)(extent, this.intersectsCoordinate.bind(this));
    }

    return false;
  };
  /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */


  Circle.prototype.setCenter = function (center) {
    var stride = this.stride;
    var radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
    var flatCoordinates = center.slice();
    flatCoordinates[stride] = flatCoordinates[0] + radius;

    for (var i = 1; i < stride; ++i) {
      flatCoordinates[stride + i] = center[i];
    }

    this.setFlatCoordinates(this.layout, flatCoordinates);
    this.changed();
  };
  /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  Circle.prototype.setCenterAndRadius = function (center, radius, opt_layout) {
    this.setLayout(opt_layout, center, 0);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }
    /** @type {Array<number>} */


    var flatCoordinates = this.flatCoordinates;
    var offset = (0, _deflate.deflateCoordinate)(flatCoordinates, 0, center, this.stride);
    flatCoordinates[offset++] = flatCoordinates[0] + radius;

    for (var i = 1, ii = this.stride; i < ii; ++i) {
      flatCoordinates[offset++] = flatCoordinates[i];
    }

    flatCoordinates.length = offset;
    this.changed();
  };

  Circle.prototype.getCoordinates = function () {
    return null;
  };

  Circle.prototype.setCoordinates = function (coordinates, opt_layout) {};
  /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */


  Circle.prototype.setRadius = function (radius) {
    this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
    this.changed();
  };
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */


  Circle.prototype.rotate = function (angle, anchor) {
    var center = this.getCenter();
    var stride = this.getStride();
    this.setCenter((0, _transform.rotate)(center, 0, center.length, stride, angle, anchor, center));
    this.changed();
  };
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */


  Circle.prototype.translate = function (deltaX, deltaY) {
    var center = this.getCenter();
    var stride = this.getStride();
    this.setCenter((0, _transform.translate)(center, 0, center.length, stride, deltaX, deltaY, center));
    this.changed();
  };

  return Circle;
}(_SimpleGeometry["default"]);
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */


Circle.prototype.transform;
var _default = Circle;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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